import React, { useState } from "react";

import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import SearchBar from "../../components/SearchBar";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate } from "react-router-dom";

type props = {
  value: number;
};

const BookingsList = ({ value }: props) => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  function createData(
    name: string,
    userName: string,
    phone: string,
    email: string,
    planName: string,
    planPrice: string,
    postedAds: string,
    earnings: string
  ) {
    return {
      name,
      userName,
      phone,
      email,
      planName,
      planPrice,
      postedAds,
      earnings,
    };
  }
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const rows = [
    createData(
      "Abdul Hussian",
      "Abdul67",
      "+971056734321",
      "abdulhussian67@gmail.com",
      "Starter",
      "1 Month / 600 SAR",
      "10",
      "600 SAR"
    ),
  ];

  return (
    <div>
      <Box className="cards_header">
        <SearchBar
        // searchTerm={searchTerm}
        // setDebouncedSearchTerm={setDebouncedSearchTerm}
        // value={searchTerm}
        // onCross={() => setSearchTerm("")}
        // onChange={(val: any) => {
        //   if (isValidInput(val.target.value)) {
        //     setSearchTerm(val.target.value);
        //   }
        // }
        // }
        />
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Booking Id</TableCell>
              <TableCell align="center">Customer Details</TableCell>
              <TableCell align="center">Property Name</TableCell>
              <TableCell align="center">Property Category</TableCell>
              <TableCell align="center">No. of Guests</TableCell>
              <TableCell align="center">Date & Time slot</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={row.name}>
                <TableCell align="center">{1}</TableCell>
                <TableCell align="center">1158</TableCell>
                <TableCell>
                  <p>Abul Hussain </p>
                  <p>abdul@yopmail.com</p>
                </TableCell>

                <TableCell> Bhumibandara Hotel</TableCell>
                <TableCell> Villa</TableCell>
                <TableCell> 3</TableCell>
                <TableCell>
                  <p>25/12/2023</p>
                  <p>11:00-18:00</p>
                </TableCell>

                {/* <TableCell>
                  <Switch {...label} defaultChecked size="small" />
                </TableCell> */}
                <TableCell>
                  <Box className="table_actions">
                    <IconButton
                      onClick={() =>
                        navigate("/manage-bookings/details", {
                          state:
                            value === 1
                              ? "CANCELLED"
                              : value === 2
                                ? "ONGOING"
                                : "COMPLETED",
                        })
                      }
                    >
                      <VisibilityIcon />
                    </IconButton>
                    {/* <IconButton
                      onClick={() => navigate("/manage-service-provider/edit")}
                    >
                      <ModeEditIcon />
                    </IconButton>
                    <IconButton>
                      <DeleteIcon />
                    </IconButton> */}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default BookingsList;
